export default class AuthenticationManager {
    constructor(api, apiB2) {
        this.api = api;
        this.apiB2 = apiB2;
    }

    login = (credentials) => this.api.login(credentials);

    loginInfo = (credentials) => this.apiB2.loginInfo(credentials);

    tokenByToken = (data) => this.api.tokenByToken(data);

    oauthLogin = (state, redirectUrl) =>
        this.apiB2.getAuthenticationToken(state, unescape(redirectUrl), -2);

    login2fa = (credentials) => this.api.login2fa(credentials);

    logout = () =>
        new Promise((resolve) => {
            resolve();
        });

    switchImplementation = (implId) =>
        this.api.switchImplementation(implId).then((response) => {
            if (response && response.token !== undefined && response.token.length > 0) {
                const { token } = response;
                return token;
            }
            return null;
        });

    getLoggedUserData = () => this.api.getLoggedUserData();

    getCfmAutoLogin = () => this.api.getCfmAutoLogin();

    getUserInfo = () => this.apiB2.getUserInfo();

    changeSandbox = (implId) => this.api.changeSandbox(implId);
}
